module.exports = __webpack_public_path__ + "static/img/whatsapp.36e01ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whatsapp.png
// module id = fHLY
// module chunks = 1